export const buildFileSelector = (multiple: boolean, accept: string)=>{
  const fileSelector = document.createElement('input');
  fileSelector.setAttribute('type', 'file');
  fileSelector.setAttribute('multiple', multiple? 'true': 'false');
  fileSelector.setAttribute('accept', accept);
  return fileSelector;
};

